import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ReturnOrderFollowUpFieldsFragmentDoc } from '../fragments/opsOrderDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetReturnOrderParcelLostMutationVariables = Types.Exact<{
  merchantOrderId: Types.Scalars['UUID'];
}>;


export type SetReturnOrderParcelLostMutation = { __typename?: 'Mutation', setReturnOrderParcelLost: { __typename?: 'ReturnOrderFollowUp', id: string, discrepancy_status?: Types.ReturnOrderDiscrepancyStatus | null, discrepancy_mail_sent_at?: string | null, resolved_at?: string | null, resolved_by?: string | null, resolution_note?: string | null, parcel_lost_at?: string | null, parcel_lost_by?: string | null, lost_container_count: number, can_set_parcel_lost: boolean, discrepancy_lines: Array<{ __typename?: 'ReturnOrderDiscrepancyLine', kind: Types.ReturnOrderLineKind, type_id: number, name?: string | null, announced: number, received: number, difference: number }> } };


export const SetReturnOrderParcelLostDocument = gql`
    mutation SetReturnOrderParcelLost($merchantOrderId: UUID!) {
  setReturnOrderParcelLost(merchant_order_id: $merchantOrderId) {
    ...ReturnOrderFollowUpFields
  }
}
    ${ReturnOrderFollowUpFieldsFragmentDoc}`;
export type SetReturnOrderParcelLostMutationFn = Apollo.MutationFunction<SetReturnOrderParcelLostMutation, SetReturnOrderParcelLostMutationVariables>;

/**
 * __useSetReturnOrderParcelLostMutation__
 *
 * To run a mutation, you first call `useSetReturnOrderParcelLostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReturnOrderParcelLostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReturnOrderParcelLostMutation, { data, loading, error }] = useSetReturnOrderParcelLostMutation({
 *   variables: {
 *      merchantOrderId: // value for 'merchantOrderId'
 *   },
 * });
 */
export function useSetReturnOrderParcelLostMutation(baseOptions?: Apollo.MutationHookOptions<SetReturnOrderParcelLostMutation, SetReturnOrderParcelLostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReturnOrderParcelLostMutation, SetReturnOrderParcelLostMutationVariables>(SetReturnOrderParcelLostDocument, options);
      }
export type SetReturnOrderParcelLostMutationHookResult = ReturnType<typeof useSetReturnOrderParcelLostMutation>;
export type SetReturnOrderParcelLostMutationResult = Apollo.MutationResult<SetReturnOrderParcelLostMutation>;
export type SetReturnOrderParcelLostMutationOptions = Apollo.BaseMutationOptions<SetReturnOrderParcelLostMutation, SetReturnOrderParcelLostMutationVariables>;